import MuiFormControlLabel from "@mui/material/FormControlLabel";

export default function FormControlLabel(props) {
  return <MuiFormControlLabel {...props} />;
}
